import axios from '@/store/interceptor';

import apiUrl from '../../config/api.config'

export async function getAllApprovalData() {
    try {
        const response = await axios.get(`${apiUrl}/responses/response-approval-data`);
        return response.data;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
}

// Everything waiting for the logged-in user's decision, along each request's own approval circuit
export async function getMyQueue() {
    const response = await axios.get(`${apiUrl}/responses/my-queue`);
    return response.data;
}

export async function getUserPhoneNumber(userId) {
    try {
        const response = await axios.get(`${apiUrl}/users/${userId}/contacts`);
        return response.data;
    } catch (error) {
        console.error("Error fetching user phone number:", error);
        throw error;
    }
}

// Earlier requests on the same physical item (across transfers, by anyone), before `requestId`
export async function getLastExecution(userId, equipmentId, requestId) {
    try {
        const response = await axios.get(`${apiUrl}/requests/last-execution`, {
            params: {
                userId,
                equipmentId,
                requestId,
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching user last execution:", error);
        throw error;
    }
}

export async function getApprovalDataByTypeAndDepartment(typeId, department) {
    try {
        const response = await axios.get(`${apiUrl}/responses/${typeId}/response-approval-user-data`, {
            params: {
                curentDepartment: department,
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
}

export async function saveResponseData(postData) {
    try {
        const response = await axios.post(`${apiUrl}/responses/`, postData, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error saving request:", error);
        throw error;
    }
}

export async function updateRequests(requestData) {
    try {
        const response = await axios.patch(`${apiUrl}/requests/${requestData.id}`, requestData, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error updating Requests:", error);
        throw error;
    }
}

export async function getMaxApproachNumber(userId, equipmentId) {
    try {
        const response = await axios.get(`${apiUrl}/requests/max-approach-number`, {
            params: {
                userId,
                equipmentId,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching max approach number:", error);
        throw error;
    }
}

export async function getRequestCommentsHistory(requestId) {
    try {
        const response = await axios.get(`${apiUrl}/requests/${requestId}/comments-history`);
        return response.data;
    } catch (error) {
        console.error('Error fetching comments history:', error);
        throw error;
    }
}

export async function getBulkRequestCommentsHistory(requestIds) {
    try {
        const response = await axios.post(`${apiUrl}/requests/bulk-comments-history`, { requestIds });
        return response.data;
    } catch (error) {
        console.error('Error fetching bulk comments history:', error);
        throw error;
    }
}

// The buttons the logged-in user may press on this request now: [{ id, label, tone }]
export async function getNextSteps(requestId) {
    const response = await axios.get(`${apiUrl}/responses/${requestId}/next-steps`);
    return response.data;
}

// The request as filed + `actions` (what the caller may do with it)
export async function getRequestDetails(requestId) {
    const response = await axios.get(`${apiUrl}/requests/${requestId}/requests-details`);
    return response.data[0] || null;
}

// Models already used for this equipment type (the field stays free text)
export async function getModelSuggestions(equipmentTypeId) {
    const response = await axios.get(`${apiUrl}/peripherals/suggestions`, { params: { equipmentTypeId } });
    return response.data;
}

export async function getLocations() {
    const response = await axios.get(`${apiUrl}/locations`);
    return response.data;
}

// Staff edit of the item a request created; logged as "Date modificate", the request does not move
export async function updateRequestItem(requestId, data) {
    const response = await axios.patch(`${apiUrl}/requests/${requestId}/item`, data);
    return response.data;
}

// A comment on a demer at any time (text and/or up to 6 photos): a timeline entry, the request does not move
export async function addRequestComment(requestId, data) {
    const response = await axios.post(`${apiUrl}/requests/${requestId}/comments`, data);
    return response.data;
}
